import React from 'react';
import classNames from '../../../helpers/classNames.js';
import ModalContent from './ModalContent.js';
import Container from '../../Container.js';
import ModalBodyActions from './ModalBodyActions.js';
import ModalBodyText from './ModalBodyText.js';
import ModalIllustration from './ModalIllustration.js';
const ModalPredefinedGeneric = ({
  headline,
  line1,
  line2,
  boldText,
  imageUrl,
  primaryButton,
  secondaryButton,
  onPrimary,
  onSecondary,
  dispatchHide
}) => {
  const bodyClassNames = classNames('ebds-modal__content__body', {
    '--with-illustration': imageUrl,
    '--with-bold-text': boldText
  });
  let handlePrimary = onPrimary;
  let handleSecondary = onSecondary;
  if (primaryButton && !onPrimary) {
    handlePrimary = dispatchHide;
  }
  if (secondaryButton && !onSecondary) {
    handleSecondary = dispatchHide;
  }
  return /*#__PURE__*/React.createElement(ModalContent, {
    type: "generic"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    className: bodyClassNames
  }, /*#__PURE__*/React.createElement(ModalIllustration, {
    imageUrl: imageUrl
  }), /*#__PURE__*/React.createElement(ModalBodyText, {
    headline: headline,
    line1: line1,
    line2: line2
  }), /*#__PURE__*/React.createElement(ModalBodyActions, {
    primaryButton: primaryButton,
    secondaryButton: secondaryButton,
    onSecondary: handleSecondary,
    onPrimary: handlePrimary
  }))));
};
export default ModalPredefinedGeneric;